import { render, staticRenderFns } from "./IdNumber.vue?vue&type=template&id=36cc246a&"
import script from "./IdNumber.vue?vue&type=script&lang=js&"
export * from "./IdNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports